// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* TODO: Maybe Remove File */\n/* @import 'react-toolbox/variables.css'; */\n.css__container___1X9L4 {\n}\n.css__centerTableContainer___wqiE0 {\n  flex: 1;\n  padding-top: 15px;\n\n}\n.css__leftContainer___32vK3 {\n  display: flex;\n}\n.css__tableBarWrapper___3-gid {\n  background-color: white;\n  box-shadow: var(--shadow-3p);\n}\n.css__resultTable___1XlCp {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n.css__messageList___1CiMO {\n  padding-left: 12px;\n}", ""]);
// Exports
exports.locals = {
	"container": "css__container___1X9L4",
	"centerTableContainer": "css__centerTableContainer___wqiE0",
	"leftContainer": "css__leftContainer___32vK3",
	"tableBarWrapper": "css__tableBarWrapper___3-gid",
	"resultTable": "css__resultTable___1XlCp",
	"messageList": "css__messageList___1CiMO"
};
module.exports = exports;
